const Numeric = {
  format (value) {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }
}

export default Numeric
